export enum ROBOT_COMMAND_TYPE {
    BEGIN = 'begin',
    CREATE_FIELD = 'create_field',
    CREATE_WALLS = 'create_walls',
    SET_CELL_TYPE = 'set_cell_type',
    SET_CELL_COLOR = 'set_cell_color',
    SET_REQUIRED_COLOR = 'set_required_color',
    SET_TEMPERATURE = 'set_temperature',
    SET_RADIATION = 'set_radiation',
    CREATE_LABEL = 'create_label',
    CREATE_PARKING_POINT = 'create_parking_point',
    FINISH_INIT = 'finish_init',
    ROBO_MOVE = 'robo_move',
    TEMP_OF_CELL = 'temp_of_cell',
    COLOR_OF_CELL = 'color_of_cell',
    GET_CELL_TEMP = 'get_cell_temp',
    CELL_IS_CLEAN = 'cell_is_clean',
    CELL_IS_FILLED = 'cell_is_filled',
    FREE_FROM_LEFT = 'free_from_left',
    FREE_FROM_RIGHT = 'free_from_right',
    FREE_FROM_DOWN = 'free_from_down',
    FREE_FROM_UP = 'free_from_up',
    WALL_IS_ON_THE_LEFT = 'wall_is_on_the_left',
    WALL_IS_ON_THE_RIGHT = 'wall_is_on_the_right',
    WALL_IS_ON_THE_DOWN = 'wall_is_on_the_down',
    WALL_IS_ON_THE_UP = 'wall_is_on_the_up',
    FINISH = 'finish',
}

export const ROBOT_LINE_NUMBER = 'l' as const;

export enum ROBOT_COORD {
    HORIZONTAL = 'n',
    VERTICAL = 'm',
}

export enum ROBOT_FINISH_STATUS {
    OK = 'OK',
    PS = 'PS',
}

export enum ROBOT_WALL {
    LEFT = 1 << 0,
    RIGHT = 1 << 1,
    TOP = 1 << 2,
    BOTTOM = 1 << 3,
}

export enum ROBOT_TASK_WALL {
    LEFT = 0,
    RIGHT = 1,
    TOP = 3,
    BOTTOM = 2,
}

export enum ROBOT_CELL_TYPE {
    EMPTY = 0,
    TO_BE_FILLED = 1,
    FILLED = 2,
}

export enum ROBOT_RUN_STATUS {
    IDLE = 'idle',
    LOADING = 'loading',
    PLAY = 'play',
    STEP = 'step',
    FINISH = 'finish',
}
